import Vue from "vue";

import config from "@/config";

const user = {};
const base = config.api_base + "/user"

user.visitorMini = (params)=>Vue.axios.post( base + "/visitor-mini",params);
user.visitorOfficial = (params)=>Vue.axios.post( base + "/visitor-official",params);
user.visitorOfficialSub = (params)=>Vue.axios.post( base + "/visitor-official-sub",params);

user.search = (params)=>Vue.axios.post( base + "/search",params);
user.one = (params)=>Vue.axios.post( base + "/one",params);
user.handsRegister = (params)=>Vue.axios.post( base + "/hands-register",params);

user.cashSearch = (params)=>Vue.axios.post( base + "/cash-search",params);
user.cashPay = (params)=>Vue.axios.post( base + "/cash-pay",params);
user.cashFail = (params)=>Vue.axios.post( base + "/cash-fail",params);
user.cashCheck = (params)=>Vue.axios.post( base + "/cash-check",params);

user.detail = (params)=>Vue.axios.post( base + "/detail",params);

user.selInviteU = (params)=>Vue.axios.post( base + "/sel-invite-u",params);


user.inviteLinkSearch = (params)=>Vue.axios.post( base + "/invite-link-search",params);
user.awardLog = (params)=>Vue.axios.post( base + "/award-log",params);
user.cashLog = (params)=>Vue.axios.post( base + "/cash-log",params);

export default user